module.exports = __webpack_public_path__ + "static/media/injuredCalm.78de2b7a.mp3";